import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import Pagination from "react-js-pagination";
import moment from "moment";

import { FetchResult } from "../../../services/doFetch";
import { PagedResult, GameSummaries, PLAYER_KEY } from "../../../types/GameTypes";
import useAsyncError from "../../../services/useAsyncError";
import { fetchPlayerGames } from "../../../services/GameService";
import useLocalStorage from "../../../services/useLocalStorage";
import Spinner from "../../UI/Spinner";

import "./PlayerGames.scss";

const pageSize = 18;

function LeaderboardPlayerGames() {
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [result, setResult] = useState<FetchResult<PagedResult<GameSummaries>>>({ loading: false });

  const [player] = useLocalStorage(PLAYER_KEY, "");

  const throwError = useAsyncError();

  const { loading, data } = result;

  useEffect(() => {
    (async () => {
      try {
        await fetchPlayerGames(player, pageNumber, pageSize, setResult);
      } catch (e) {
        throwError(e);
      }
    })();
  }, [throwError, pageNumber, player]);

  const summaries = data?.data;
  const pagingMeta = data?.meta;

  function onPageChange(pageNumber: number) {
    setPageNumber(pageNumber);
    console.log(pageNumber);
  }

  return (
    <div className="leaderboard-player-games">
      {loading && (
        <div className="spinner">
          <Spinner />
        </div>
      )}

      {summaries && (
        <>
          <div className="recent-games leaderboard-pane">
            <table>
              <tbody>
                {summaries.map((summary) => (
                  <tr key={summary.nonce}>
                    {/*<td>
                      <span className="player">{summary.player}</span>
                    </td>*/}
                    <td>{moment(summary.ended).calendar(null, { sameElse: "MMM Do YYYY" })}</td>
                    <td>
                      <Link to={`/game/${summary.nonce}`}>{summary.score}</Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <Pagination
            activePage={pageNumber}
            itemsCountPerPage={pageSize}
            totalItemsCount={pagingMeta!.totalCount}
            pageRangeDisplayed={5}
            onChange={onPageChange}
            nextPageText="➼"
            lastPageText="➽"
            prevPageText="➼"
            firstPageText="➽"
            itemClassFirst="rotate180"
            itemClassPrev="rotate180"
          />
        </>
      )}
    </div>
  );
}

export default LeaderboardPlayerGames;
